import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/_services/common.service';
import { IUser } from 'src/app/_interfaces/IUser.types';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  apiBaseUrl = environment.apiBaseUrl;
  private userSubject: BehaviorSubject<IUser>;
  public userObservable: Observable<IUser>;

  constructor(
    private _httpClient: HttpClient,
    private _commonService: CommonService
  ) {
    const ls = localStorage.getItem('user');
    const u = ls ? JSON.parse(ls) : {};
    this.userSubject = new BehaviorSubject<IUser>(u);
    this.userObservable = this.userSubject.asObservable();
  }

  /**
   * Setter & getter for user
   *
   * @param user
   */
  set user(user: IUser)
  {
    if(!user?.photoUrl) {
      user.photoUrl = this._commonService.avtar;
    }

    const u = {
      _id: user._id,
      firstName: user.firstName,
      lastName: user.lastName,
      phoneNumber: user.phoneNumber,
      photoUrl: user.photoUrl,
    };

    // Store the value
    this.userSubject.next(user);

    localStorage.setItem('user', JSON.stringify(user));
  }

  public get user(): IUser {
    let user = this.userSubject.value;
    if(!user) {
      const ls = localStorage.getItem('user');
      user = ls ? JSON.parse(ls) : {};
    }
    return user;
  }

  update(params: { firstName?: string, lastName?: string, phoneNumber?: string, photoUrl?: string }) {
    return this._httpClient.put(`${this.apiBaseUrl}/auth/update`, params);
  }

  getUser() {
    return this._httpClient.get(`${this.apiBaseUrl}/auth/user`);
  }

  clearUser() {
    localStorage.removeItem('user');
  }
}
